import {
  ClockIcon,
  AlertCircleIcon,
  BarChart3Icon,
  ShieldAlertIcon,
  ZapIcon,
  MonitorIcon,
  MessageCircleIcon,
  MapIcon,
  LayersIcon,
  ShieldIcon,
  TimerIcon,
  CheckCircle2Icon,
  UsersIcon,
  TargetIcon,
  LightbulbIcon
} from 'lucide-react';

// --- Vistazo al interior: carrusel de páginas reales ---
export const lookInsideImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/aqvrvvRsZfWFkdANevabXh/WhatsApp_Image_2026-09-09_at_19.49.45_(3).webp',
    alt: 'Página real: Descompón Números de Tres Cifras'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cda3YxMGmt6DTkith6n8uP/WhatsApp_Image_2026-09-09_at_19.49.45_(1).webp',
    alt: 'Página real: Suma de Números Enteros'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/qddiTmmEFVvgQ6XNimH5vp/WhatsApp_Image_2026-09-09_at_19.49.45.webp',
    alt: 'Página real: Operaciones Combinadas con Enteros'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fVPmkHR4YL96tKPhiTsAnv/WhatsApp_Image_2026-09-09_at_19.49.44.webp',
    alt: 'Página real: Términos Semejantes'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/drXPwgT7hVgyQbCfDr3keb/WhatsApp_Image_2026-09-09_at_19.49.44_(1).webp',
    alt: 'Página real: Potencias de Números Enteros'
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sZWhQgq2dQLa7LMxJytHEd/WhatsApp_Image_2026-09-09_at_19.49.45_(2).webp',
    alt: 'Página real: Calcular la Hipotenusa'
  }
];

// --- Section 3: El problema ---
export const problems = [
  {
    icon: ClockIcon,
    emoji: '⏰',
    title: 'Horas de preparación robadas',
    text: 'Pasas 2-3 horas preparando clases que deberían estar listas. Noches. Fines de semana. Tiempo que no tienes.'
  },
  {
    icon: AlertCircleIcon,
    emoji: '😰',
    title: 'Estrés de última hora',
    text: 'Llega lunes. Aún no tienes la clase de martes. Sustituciones imprevistas. Cambios de horario. Todo se desmorona.'
  },
  {
    icon: BarChart3Icon,
    emoji: '📊',
    title: 'Inconsistencia que nota el alumno',
    text: 'Lunes explicación clara. Miércoles improviso. Los alumnos no saben qué esperar. Evaluaciones desalineadas.'
  },
  {
    icon: ShieldAlertIcon,
    emoji: '🎯',
    title: 'Miedo a inspección',
    text: '¿Estoy dentro de normativa? ¿Mis evaluaciones son justas? ¿Mi programación es sólida?'
  }
];

// --- Section 5: Los 12 tomos ---
export const volumes = [
  {
    emoji: '📘',
    title: 'Tomo 1-2: 1.º-2.º Primaria',
    text: 'Números, operaciones básicas, geometría inicial. Método claro. Ejercicios listos. Evaluaciones incluidas.'
  },
  {
    emoji: '📗',
    title: 'Tomo 3-4: 3.º-4.º Primaria',
    text: 'Multiplicación, división, fracciones, medida. Estructurado por bloques. Progresión garantizada.'
  },
  {
    emoji: '📙',
    title: 'Tomo 5-6: 5.º-6.º Primaria',
    text: 'Decimales, porcentajes, geometría aplicada, estadística. Conexión con vida real.'
  },
  {
    emoji: '📕',
    title: 'Tomo 7-8: 1.º-2.º ESO',
    text: 'Álgebra desde cero, proporcionalidad, ecuaciones, funciones. Sin saltos.'
  },
  {
    emoji: '📔',
    title: 'Tomo 9-10: 3.º-4.º ESO',
    text: 'Sistemas, trigonometría, probabilidad, estadística avanzada.'
  },
  {
    emoji: '📓',
    title: 'Tomo 11-12: 1.º-2.º Bachillerato',
    text: 'Análisis, álgebra lineal, preparación EBAU. Contenidos profundos.'
  }
];

// --- Section 6: Los 6 bonos ---
export const bonuses = [
  {
    icon: ZapIcon,
    title: 'Kit Clase Lista en 10 Minutos',
    text: 'Plantillas y estructura exacta para convertir cualquier tomo en una clase funcional. Sin extra preparación.',
    pages: '25 páginas',
    value: '20€'
  },
  {
    icon: MonitorIcon,
    title: 'Guía de Proyección Matemática en Clase',
    text: 'Cómo llevar los tomos al aula de forma que engancha. Evita monótonos. Mantiene atención. Interacción constante.',
    pages: '24 páginas',
    value: '18€'
  },
  {
    icon: MessageCircleIcon,
    title: 'Scripts de Explicación Matemática Sin Bloqueos',
    text: '30 guiones docentes para cuando un alumno se bloquea. Explicaciones que funcionan. Visualización clara. Sin improvisar.',
    pages: '30 páginas',
    value: '22€'
  },
  {
    icon: MapIcon,
    title: 'Mapa de Errores Frecuentes y Rescate Rápido',
    text: '22 errores típicos. Diagnóstico instantáneo. Corrección en 30 segundos a 2 minutos. Sistema que funciona.',
    pages: '28 páginas',
    value: '24€'
  },
  {
    icon: LayersIcon,
    title: 'Mini Sistema Aula Multinivel',
    text: 'Adapta una clase a 3 niveles sin preparar tres clases. Base, Consolidación, Reto. Inclusión real. Nadie se queda atrás.',
    pages: '26 páginas',
    value: '16€'
  },
  {
    icon: ShieldIcon,
    title: 'Plan Anti-Caos para Clases Imprevistas',
    text: 'Sustituciones, cambios de horario, días complicados. Planes listos para 20, 30, 45, 55 minutos. Tu salvavidas.',
    pages: '22 páginas',
    value: '20€'
  }
];

// --- Section 7: Tabla de valor ---
export const valueRows = [
  { concept: '12 Tomos (planificación anual completa)', value: '120€' },
  { concept: 'Kit Clase Lista en 10 Minutos', value: '20€' },
  { concept: 'Guía de Proyección en Clase', value: '18€' },
  { concept: 'Scripts de Explicación Matemática', value: '22€' },
  { concept: 'Mapa de Errores Frecuentes y Rescate', value: '24€' },
  { concept: 'Mini Sistema Aula Multinivel', value: '16€' },
  { concept: 'Plan Anti-Caos para Clases Imprevistas', value: '20€' }
];
export const valueTotal = '240€';

// --- Section 9: Por qué funciona ---
export const features = [
  {
    icon: TimerIcon,
    emoji: '⏱️',
    title: '10 Minutos de Prep',
    text: 'Abre un tomo, elige el bloque, prepara la clase. Sin horas. Sin estrés. Mañana ya está todo listo.'
  },
  {
    icon: CheckCircle2Icon,
    emoji: '✅',
    title: 'Estructura Garantizada',
    text: 'Cada lección tiene objetivo claro, explicación, ejemplos, ejercicios y evaluación. Nada falta. Nada sobra.'
  },
  {
    icon: BarChart3Icon,
    emoji: '📊',
    title: 'LOMLOE Alineado',
    text: 'Competencias clave integradas. Evaluación formativa. Programación anual lista. Inspección confía.'
  },
  {
    icon: UsersIcon,
    emoji: '👥',
    title: 'Funciona en Aula Real',
    text: 'Base, Consolidación, Reto. Un sistema que adapta a todos los ritmos. Sin duplicar trabajo.'
  },
  {
    icon: TargetIcon,
    emoji: '🎯',
    title: 'De 1.º Primaria a Bachillerato',
    text: '12 tomos. Cobertura total. Cualquiera sea tu curso, funciona. Continuidad garantizada.'
  },
  {
    icon: LightbulbIcon,
    emoji: '💡',
    title: 'Diseñado por Profesores Reales',
    text: 'Testado en aulas. Feedback de docentes integrado. No es teoría. Es lo que funciona hoy.'
  }
];

// --- Section 10: Testimonios ---
export const testimonials = [
  {
    text: 'Pasaba 10 horas cada semana preparando. Con Matemáticas Listo, 30 minutos. Los alumnos aprenden mejor. Yo tengo vida.',
    name: 'María García',
    role: 'Maestra de Primaria, Madrid'
  },
  {
    text: 'Las sustituciones eran un caos. Ahora, con los tomos listos, cualquiera puede dar clase sin problema. Todo funciona.',
    name: 'Carlos Rodríguez',
    role: 'Profesor de ESO, Barcelona'
  },
  {
    text: 'El Mapa de Errores me muestra exactamente dónde está el bloqueo. Corrijo en segundos. Los alumnos entienden mejor.',
    name: 'Elena Martínez',
    role: 'Profesora de Bachillerato, Valencia'
  },
  {
    text: 'El Sistema Multinivel cambió todo. Ahora Base no se siente mal, Reto no se aburre. Todos avanzan.',
    name: 'Juan López',
    role: 'Profesor de ESO, Sevilla'
  }
];

// --- Section 11: Cómo funciona ---
export const howItWorksSteps = [
  { n: '1', text: 'Recibes acceso inmediato a los 12 tomos y 6 bonos.' },
  { n: '2', text: 'Abres el tomo de tu curso. Eliges el bloque que necesitas hoy.' },
  { n: '3', text: 'Usas la estructura lista (Kit Clase Lista en 10 Minutos). Completa la preparación en 10 minutos.' },
  { n: '4', text: 'Llevas la clase al aula. Explicas, haces ejercicios, cierras.' },
  {
    n: '5',
    text: 'Los bonos te apoyan en cada momento: Scripts cuando se bloquean, Mapa de Errores para corregir rápido, Plan Anti-Caos para imprevistos.'
  }
];
export const howItWorksResult = 'Clases estructuradas. Alumnos que aprenden. Tú sin estrés.';

// --- Section 13: FAQ ---
export const faqs = [
  {
    q: '¿Qué necesito para usar Matemáticas Listo?',
    a: 'Solo el tomo en formato digital (PDF o documento). Lo imprimes, lo llevas al aula, o lo consultas en pantalla. Es simple. Sin requisitos técnicos especiales.'
  },
  {
    q: '¿Cubre todos los niveles?',
    a: 'Sí. 12 tomos desde 1.º Primaria hasta 2.º Bachillerato. Compras el sistema completo, pero usarás principalmente los de tu nivel. Tener todo disponible te da flexibilidad futura.'
  },
  {
    q: '¿Está alineado con LOMLOE?',
    a: 'Completamente. Competencias clave integradas. Evaluación formativa. Programación anual estructurada. Es normativa actual, no improvisación.'
  },
  {
    q: '¿Cuánto tiempo realmente necesito de prep?',
    a: 'El Kit Clase Lista en 10 Minutos lo especifica: 10 minutos. Primer uso, quizá 15-20. Después, 10 o menos. Es el tiempo de abrir, elegir, revisar.'
  },
  {
    q: '¿Qué pasa si tengo una sustitución?',
    a: 'El Plan Anti-Caos incluye instrucciones lisas para el profesor sustituto. Dejas el tomo, el plan y todo funciona. Sin caos. Sin que se pierda clase.'
  },
  {
    q: '¿Recibiré actualizaciones?',
    a: 'Sí. Cualquier mejora, ajuste o adición, lo recibes. Tu acceso es de por vida. Un solo pago de 19€.'
  },
  {
    q: '¿Cuándo tengo acceso?',
    a: 'Inmediatamente después de comprar. Email con acceso a todos los tomos y bonos. Dentro de minutos, descargando. Mañana ya usas la primera clase.'
  }
];

// --- Section 14: Objeciones comunes ---
export const objections = [
  {
    q: '"Pero yo siempre he preparado mis propias clases."',
    a: 'Claro. Y funciona. Pero ¿cuántas horas te cuesta? Matemáticas Listo no te quita libertad. Te quita carga. Usas los tomos como base, personalizas si quieres.'
  },
  {
    q: '"¿Y si no se adapta a mi grupo?"',
    a: 'El Sistema Multinivel (Bono 5) hace eso exactamente. Adapta una clase a 3 niveles. Tu grupo tiene ritmos distintos. El sistema los gestiona sin duplicar trabajo.'
  },
  {
    q: '"19€ parece demasiado barato. ¿Será de calidad?"',
    a: 'Porque queremos que lo pruebes. 240€ es el valor real (tomos + bonos por separado). Hoy es 19€. Garantía 7 días.'
  }
];
